<template>
	<div class="conPersonal">
		<div class="formPersonal">
			<div class="right-SecondTitle">
				<div class="h4">个人实名认证</div>
				<a @click="back"> 返回上一级 </a>
				<div class="line"></div>
			</div>
			<div class="MainStepsForm">
				<div class="formWrap fl">
					<el-form ref="form" :model="form" :rules="rules" label-width="180px">
						<el-form-item label="姓名" prop="userName">
							<el-input v-model="form.userName" placeholder="请输入姓名" :disabled="isDisabled"></el-input>
							<div class="blockReminder blockReminder2" v-if="isDisabled">
								<div class="description" slot="description">请通过上传身份证进行识别</div>
							</div>
						</el-form-item>
						<el-form-item label="证件类型" prop="identityType">
							<el-select v-model="identityName" @change="selectChanged">
								<el-option v-for="item in user" :key="item.id" :lable="item.id" :value="item.identityName"></el-option>
							</el-select>
                        </el-form-item>
                        <el-form-item label="证件号" prop="uniqueCode">
                            <el-input v-model="form.uniqueCode" placeholder="请输入证件号" @input="
                            form.uniqueCode = form.uniqueCode.replace(/[\W]/g,'')" :disabled="isDisabled"></el-input>
							<div class="blockReminder blockReminder2" v-if="isDisabled">
								<div class="description" slot="description">请通过上传身份证进行识别</div>
							</div>
                        </el-form-item>
						<el-form-item label="联系方式" prop="contactPhone">
                            <el-input v-model="form.contactPhone" placeholder="请输入联系方式" @input="
                            form.contactPhone = form.contactPhone.replace(/[^\d-]/g,'')"></el-input>
                        </el-form-item>
                        <el-form-item label="证件是否长期有效" prop="longValid">
                            <el-radio-group v-model="form.longValid" @change="changeLongValid">
								<el-radio label="1" :disabled="isDisabled">是</el-radio>
								<el-radio label="2" :disabled="isDisabled">否</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="证件有效时间" prop="startDate">
							<el-col :span="11">
								<el-date-picker type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="timestamp" v-model="form.startDate"
								 style="width: 100%;" :disabled="isDisabled"></el-date-picker>
							</el-col>
							<el-col :span="2" v-if="this.form.longValid == '2'" style="text-align: center;">-</el-col>
							<el-col :span="11" v-if="this.form.longValid == '2'">
								<el-date-picker type="date" placeholder="截止日期" format="yyyy-MM-dd" value-format="timestamp" v-model="form.expireDate"
								 style="width: 100%;" :disabled="isDisabled"></el-date-picker>
								 <div class="blockReminder blockReminder2" v-if="isDisabled">
									<div class="description" slot="description">请通过上传身份证进行识别</div>
								</div>
							</el-col>
						</el-form-item>
						<el-form-item label="国家省市" prop="province"  :rules="[{ required: true, validator: valiCity, trigger: 'blur' }]">
							<china-area-data @change="cityChange"></china-area-data>
						</el-form-item>
						<!-- <el-form-item label="详细地址" prop="address">
							<el-input v-model="form.address" placeholder="请输入详细地址" :disabled="isDisabled"></el-input>
						</el-form-item> -->
						<el-form-item label="上传身份证" prop="additionalProp1" :rules="[{ required: true, validator: valiIcon, trigger: 'blur' }]">
							<div class="uploadIDcard"  >
								<el-upload class="Uploader fl" :action="uploadUrl" :headers="uploadHeaders" :show-file-list="false" :on-success="uploadSuccess1"
								 :before-upload="uploadBefore1" v-loading="loading1">
									<img v-if="form.identityPicture.additionalProp1" :src="form.identityPicture.additionalProp1" class="avatar">
									<i v-else class="el-icon-plus avatar-uploader-icon"><p>上传人像面</p></i>
								</el-upload>
								<el-upload class="Uploader fl" :action="uploadUrl" :headers="uploadHeaders" :show-file-list="false" :on-success="uploadSuccess2"
								 :before-upload="uploadBefore2" v-loading="loading2">
									<img v-if="form.identityPicture.additionalProp2" :src="form.identityPicture.additionalProp2" class="avatar">
									<i v-else class="el-icon-plus avatar-uploader-icon"><p>上传国徽面</p></i>
								</el-upload>
								<!-- <el-upload class="Uploader fl" :action="uploadUrl" :headers="uploadHeaders" :show-file-list="false" :on-success="uploadSuccess3"
								 :before-upload="uploadBefore3">
									<img v-if="form.identityPicture.additionalProp3" :src="form.identityPicture.additionalProp3" class="avatar">
									<i v-else class="el-icon-plus avatar-uploader-icon"><p>上传手持证件人照片</p></i>
								</el-upload> -->
								<div class="clear"></div>
							</div>

							<i class="iconfont iconRotate" @click="rotateImage(90)">&#xe69e;</i>
							<i class="iconfont iconRotate" @click="rotateImage2(90)">&#xe69e;</i>
							<div class="clear"></div>

							<div class="blockReminder">
								<div class="h3">上传证件要求：</div>
								<div class="description" slot="description">
									1、上传的证件内容必须清晰可见<br>
									2、作者名称和证件号码与提交的证件信息一致<br>
									3、要求不得涂改，需确保四边角完整，水印、文字、图片、证件号码等清晰可辨<br>
									4、须小于5MB，且为JPG/PNG格式，尺寸过小不宜上传(推荐800*600以上)<br>
									5、证件在有效期之内
								</div>
							</div>
							<div class="exampleWrap">
								上传证件示例：
								<div class="exampleimg"></div>
							</div>
						</el-form-item>
						<el-form-item label="上传电子签名" prop="signature" :rules="[{ required: true, validator: valiIcon2, trigger: 'blur' }]">
							<div class="uploadBusinessLicense" >
								<!-- <el-upload class="Uploader2 fl"  :action="uploadUrl"  :headers="uploadHeaders" :show-file-list="false" :on-success="uploadSuccess4"
								 :before-upload="uploadBefore4" v-loading="loading4">
									<img v-if="form.supportingMaterial.signature" :src="form.supportingMaterial.signature" class="avatar">
									<i v-else class="el-icon-plus avatar-uploader-icon"></i>
								</el-upload> -->
	<!-- 裁剪图片基本使用 -->
    <upload-cropper
      :width="300"
      :height="300"
	  :signature-type="'qianming'"
	  @confirm-crop="handleUploadImage"
	  :signature-url="form.supportingMaterial.signature"
    />
								<el-upload class="originalUpload"  :action="uploadUrl"  :headers="uploadHeaders" :show-file-list="false" :on-success="uploadSuccess4"
									:before-upload="uploadBefore4">
									<el-button type="mini">原图上传</el-button>
								</el-upload>
								<div class="clear"></div>
							</div>
							<div class="blockReminder">
								<div class="description" slot="description">
									推荐尺寸：320*180 的等比例PNG图片
								</div>
							</div>
						</el-form-item>
						<el-form-item class="submitRow">
							<el-button type="primary" @click="onSubmit('form')">确认提交</el-button>
						</el-form-item>
					</el-form>
				</div>
				<!-- <div class="blockReminder fl">
					<div class="h3">上传证件要求：</div>
					<div class="description" slot="description">
						1、上传的证件内容必须清晰可见<br>
						2、作者名称和证件号码与提交的证件信息一致<br>
						3、要求不得涂改，需确保四边角完整，水印、文字、图片、证件号码等清晰可辨<br>
						4、须小于5MB，且为JPG/PNG格式，尺寸过小不宜上传(推荐800*600以上)<br>
						5、证件在有效期之内
					</div>
				</div> -->
				<div class="clear"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import UploadCropper from '@/components/form/UploadCropper.vue'
	import {
		createObligee,ocrBoth
	} from '@/api/ObligeeService'
	import ChinaAreaData from '@/components/ChinaAreaData'
	export default {
		name: 'Personal',
		components: { ChinaAreaData,UploadCropper },
		data() {
			return {
				form: {
					userName: '',
					obligeeType: '1',
					identityPicture: {
						additionalProp1: '',
						additionalProp2: '',
						additionalProp3: ''
					},
					uniqueCode: '',
					contactPhone: '',
					startDate: '',
					expireDate: '',
					province: '',
					city: '',
					address: '',
					longValid: "2",
					identityType: '1',
					supportingMaterial: {signature: ''},
					inputType: '00',	//自动识别 inputType为00，手工输入为01
				},
				uploadUrl: `${process.env.VUE_APP_BASEURL}/v1/ins/file/upload?path=exist/evidence/files/` + Math.random().toString(36).substr(2, 9), // 添加随机数,
				uploadHeaders: {
					'Authorization': this.$store.getters.token,
					'Product-Mode': "READ",
					'Terminal-Code': "IPCHAIN2" + this.$store.getters.terminalCode,
					'Terminal-Type': "WEB",
					'Merchant-Id': "5"
				},
				rotation: 0,
      			originalFile: null,
      			originalFile2: null,
				rules: {
					userName: [{
							required: true,
							message: '请输入姓名',
							trigger: 'blur'
						},
						{
							min: 2,
							max: 50,
							message: '长度在 2 到 50 个字符',
							trigger: 'blur'
						}
					],
					identityType: [{
						required: true,
						message: '请选择证件类型',
						trigger: 'blur'
					}],
					uniqueCode: [{
						required: true,
						message: '请输入证件号码',
						trigger: 'change'
					},
						{
							min: 15,
							max: 18,
							message: '长度在 15 到 18 个字符',
							trigger: 'blur'
						}],
						contactPhone: [
						{ 
							required: true, 
							message: '请输入联系方式', 
							trigger: 'blur' 
						},
						{ 
							validator: (rule, value, callback) => {
								// 手机号：11位数字，以1开头
								const mobileRegex = /^1\d{10}$/;
								// 座机号：区号-号码，如 010-88888888 或 0755-88888888
								const phoneRegex = /^0\d{2,3}-\d{7,8}$/;
								// 座机号无横线格式
								const phoneRegex2 = /^0\d{2,3}\d{7,8}$/;
								
								if (mobileRegex.test(value) || phoneRegex.test(value) || phoneRegex2.test(value)) {
									callback();
								} else {
									callback(new Error('请输入正确的手机号或座机号（如：010-88888888）'));
								}
							}, 
							trigger: 'blur' 
						}
					],
					longValid: [{
						required: true,
					}],
					startDate: [{
						// type: 'date',
						required: true,
						message: '请选择开始日期',
						trigger: 'change'
					}],
					expireDate: [{
						// type: 'date',
						required: true,
						message: '请选择截止日期',
						trigger: 'change'
					}],
					address: [{
						required: true,
						message: '请输入家庭地址',
						trigger: 'blur'
					}]
				},
				imageUrl: '',

				other: [
					{
						"id": 8,
						"orders": 1,
						"parentId": 3,
						"identityName": "组织机构代码证书/其他证书"
					}
				],
				user: [
					{
						"id": 1,
						"orders": 1,
						"parentId": 1,
						"identityName": "身份证"
					},
					{
						"id": 10,
						"orders": 2,
						"parentId": 1,
						"identityName": "军官证"
					},
					{
						"id": 11,
						"orders": 3,
						"parentId": 1,
						"identityName": "学生证"
					},
					{
						"id": 9,
						"orders": 4,
						"parentId": 1,
						"identityName": "其他证件"
					}
				],
				identityName: '身份证',
				
				isDisabled: true,

				loading1: false,
				loading2: false,
				loading4: false,
			}
		},
		methods: {
			back() {
				this.$emit('set-tab-idx', 'tab1')
			},
			valiIcon(rule, value, callback){
					if (!this.form.identityPicture.additionalProp1) {
					  callback(new Error('请上传身份证正面'));
					  return; 
					} 
					if (!this.form.identityPicture.additionalProp2) {
					  callback(new Error('请上传身份证反面'));
					  return; 
					}
					// if (!this.form.identityPicture.additionalProp3) {
					//   callback(new Error('请上传手持证件人照片'));
					//   return;
					// }
					callback();
			},
			valiIcon2(rule, value, callback){
				if (!this.form.supportingMaterial.signature) {
					callback(new Error('上传个人电子签名'));
					return; 
				}
				callback();
			},
			valiCity(rule, value, callback){ 
					if (!this.form.province) {
					  callback(new Error('请选择省份'));
					  return;
					}
					if (!this.form.city) {
					  callback(new Error('请选择城市'));
					  return;
					}
					// if (!this.form.area) {
					//   callback(new Error('请选择区县'));
					//   return;
					// }
					callback();
			},
			cityChange(data) {
				// console.log(data);
				if(data.laber == 'province'){
					this.form.province = data.value;
					this.form.city = '';
				}else if(data.laber == 'city'){
					this.form.city = data.value;
				}
				this.$refs.form.validateField('province');
      			this.$refs.form.validateField('city');
				// this.form.area = data.selectData.area.name;
			},
			onSubmit(formName) {
				this.$refs[formName].validate((valid) => {
				          if (valid) {
				            this.form.startDate = this.form.startDate / 1000;
				            this.form.expireDate = this.form.expireDate / 1000;
							this.startDateText = this.form.startDate * 1000;
							this.expireDateText = this.form.expireDate * 1000;
				            let that = this;
				            createObligee(this.form).then((data) => {
								this.$message.success('实名认证成功!');
				            	that.$emit('set-tab-idx', 'tab1');
				            	that.$parent.getAuthInfo();
								this.bus.$emit("refreshObligee");  // 更新vue事件总线中vuex的著作权人列表
				            }).catch(e => {
				            	this.$message.error('服务请求失败，请稍后重试!');
				            });
				          } else {
				            console.log('error submit!!');
				            return false;
				          }
				});
				
			},
			uploadSuccess1(res, file) {
				if(!res.downloadUrl){
					this.$message.error('上传失败！');
					return false
				}
				this.form.identityPicture.additionalProp1 = res.downloadUrl;
				this.$refs.form.validateField('identityPicture.additionalProp1');
				this.loading1 = false;
				// 根据上传的身份证直接获取用户身份证信息
				if(this.form.identityType == '1'){	// 只有身份证需要识别
					// 创建Loading实例
					const loadingInstance = this.$loading({
						lock: true,
						text: '正在识别身份证信息...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					ocrBoth({frontUrl:this.form.identityPicture.additionalProp1}).then((data) => {
						loadingInstance.close(); // 关闭loading
						this.form.userName = data.data.name;
						this.form.uniqueCode= data.data.identityNo;
						// this.form.address = data.data.address;
						// this.form.province = data.data.address;
						// this.form.city = data.data.address;
					}).catch(e => {
						loadingInstance.close(); // 关闭loading
						this.$message.error('获取身份证信息失败！请手工录入实名信息。');
						this.isDisabled = false;
						this.form.inputType = '01';
					});
				}
			},
			uploadBefore1(file) {
				this.originalFile = file
				const isImage = file.type === 'image/jpeg' || file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 5;
				this.loading1 = true;
				if (!isImage) {
					this.$message.error('上传图片只能是 JPG、JPEG、PNG 格式!');
					this.loading1 = false;
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 5MB!');
					this.loading1 = false;
				}
				return isImage && isLt2M;
			},
			async rotateImage(degrees) {
				if(!this.form.identityPicture.additionalProp1){
					this.$message.error('请先上传照片!');
					return false
				}
				this.loading1 = true;
				this.rotation += degrees;
				if (!this.originalFile) return
				try {
					// 创建旋转后的图片文件
					const rotatedFile = await this.rotateAndCreateFile(this.originalFile, this.rotation)
					// 重新上传旋转后的图片
					const formData = new FormData()
					formData.append('file', rotatedFile)
					
					// 重新上传处理
					// this.$refs.uploader1.data = formData;
					// this.$refs.uploader1.submit()

					// 使用 axios 上传
					// await axios({
					// 	url: this.uploadUrl,
					// 	headers: this.uploadHeaders,
					// 	method: 'post',
					// 	data: formData
					// }).then((res) => {
					// 	console.log(res);
					// 	if (res.data.code == 200) {

					// 	}
					// })

					// 使用 Fetch API 上传
					return fetch(`${process.env.VUE_APP_BASEURL}/v1/ins/file/upload?path=exist/evidence/files/` + Math.random().toString(36).substr(2, 9), {
						method: "POST",
						body: formData,
						headers: this.uploadHeaders,
					}).then(res => res.json()).then(res => {
						if(!res.downloadUrl){
							this.$message.error('翻转失败！');
							return false
						}
						this.form.identityPicture.additionalProp1 = res.downloadUrl;
						this.$refs.form.validateField('identityPicture.additionalProp1');
						this.loading1 = false;
						this.originalFile = rotatedFile;
						this.rotation = 0;
					});

				} catch (error) {
					this.$message.error('上传失败:' + error.message)
				}
			},
			async rotateImage2(degrees) {
				if(!this.form.identityPicture.additionalProp2){
					this.$message.error('请先上传照片!');
					return false
				}
				this.loading2 = true;
				this.rotation += degrees;
				if (!this.originalFile2) return
				try {
					// 创建旋转后的图片文件
					const rotatedFile = await this.rotateAndCreateFile(this.originalFile2, this.rotation)
					// 重新上传旋转后的图片
					const formData = new FormData()
					formData.append('file', rotatedFile)
					
					// 重新上传处理
					// this.$refs.uploader1.data = formData;
					// this.$refs.uploader1.submit()

					// 使用 axios 上传
					// await axios({
					// 	url: this.uploadUrl,
					// 	headers: this.uploadHeaders,
					// 	method: 'post',
					// 	data: formData
					// }).then((res) => {
					// 	console.log(res);
					// 	if (res.data.code == 200) {

					// 	}
					// })

					// 使用 Fetch API 上传
					return fetch(`${process.env.VUE_APP_BASEURL}/v1/ins/file/upload?path=exist/evidence/files/` + Math.random().toString(36).substr(2, 9), {
						method: "POST",
						body: formData,
						headers: this.uploadHeaders,
					}).then(res => res.json()).then(res => {
						if(!res.downloadUrl){
							this.$message.error('翻转失败！');
							return false
						}
						this.form.identityPicture.additionalProp2 = res.downloadUrl;
						this.$refs.form.validateField('identityPicture.additionalProp2');
						this.loading2 = false;
						this.originalFile2 = rotatedFile;
						this.rotation = 0;
					});

				} catch (error) {
					this.$message.error('上传失败:' + error.message)
				}
			},
			rotateAndCreateFile(file, rotation) {
				return new Promise((resolve) => {
					if (rotation % 360 === 0) {
					// 不需要旋转，直接返回原文件
					resolve(file)
					return
					}
					
					const reader = new FileReader()
					reader.onload = (e) => {
					const img = new Image()
					img.onload = () => {
						const canvas = document.createElement('canvas')
						const ctx = canvas.getContext('2d')
						
						// 调整画布大小以适应旋转后的图片
						if (rotation % 180 !== 0) {
						canvas.width = img.height
						canvas.height = img.width
						} else {
						canvas.width = img.width
						canvas.height = img.height
						}
						
						// 旋转并绘制图片
						ctx.translate(canvas.width / 2, canvas.height / 2)
						ctx.rotate(rotation * Math.PI / 180)
						ctx.drawImage(img, -img.width / 2, -img.height / 2)
						
						// 转换为Blob对象
						canvas.toBlob((blob) => {
						const rotatedFile = new File([blob], file.name, {
							type: file.type,
							lastModified: Date.now()
						})
						resolve(rotatedFile)
						}, file.type)
					}
					img.src = e.target.result
					}
					reader.readAsDataURL(file)
				})
			},
			uploadSuccess2(res, file) {
				if(!res.downloadUrl){
					this.$message.error('上传失败！');
					return false
				}
				this.form.identityPicture.additionalProp2 = res.downloadUrl;
				this.$refs.form.validateField('identityPicture.additionalProp2');
				this.loading2 = false;
				// 根据上传的身份证直接获取用户身份证信息
				if(this.form.identityType == '1'){	// 只有身份证需要识别
					// 创建Loading实例
					const loadingInstance = this.$loading({
						lock: true,
						text: '正在识别身份证信息...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					ocrBoth({backUrl:this.form.identityPicture.additionalProp2}).then((data) => {
						loadingInstance.close(); // 关闭loading
						this.form.startDate = data.data.startDate * 1000;
						this.form.expireDate = data.data.endDate * 1000;
						console.log(this.form);
					}).catch(e => {
						loadingInstance.close(); // 关闭loading
						this.$message.error('获取身份证信息失败！请手工录入实名信息。');
						this.isDisabled = false;
						this.form.inputType = '01';
					});
				}
			},
			uploadBefore2(file) {
				this.originalFile2 = file
				const isImage = file.type === 'image/jpeg' || file.type === 'image/png'; 
				const isLt2M = file.size / 1024 / 1024 < 5;
				this.loading2 = true;
				if (!isImage) {
					this.$message.error('上传图片只能是 JPG、JPEG、PNG 格式!');
					this.loading2 = false;
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 5MB!');
					this.loading2 = false;
				}
				return isImage && isLt2M;
			},
			uploadSuccess3(res, file) {
				if(!res.downloadUrl){
					this.$message.error('上传失败！');
					return false
				}
				this.form.identityPicture.additionalProp3 = res.downloadUrl;
				this.$refs.form.validateField('identityPicture.additionalProp3');
				this.loading3 = false;
			},
			uploadBefore3(file) {
				const isImage = file.type === 'image/jpeg' || file.type === 'image/png'; 
				const isLt2M = file.size / 1024 / 1024 < 5;
				this.loading3 = true;
				if (!isImage) {
					this.$message.error('上传图片只能是 JPG、JPEG、PNG 格式!');
					this.loading3 = false;
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 5MB!');
					this.loading3 = false;
				}
				return isImage && isLt2M;
			},
			uploadSuccess4(res, file) {
				if(!res.downloadUrl){
					this.$message.error('上传失败！');
					return false
				}
				this.form.supportingMaterial.signature = res.downloadUrl;
				this.$refs.form.validateField('supportingMaterial.signature');
				this.loading4 = false;
			},
			uploadBefore4(file) {
				console.log(file);
				// 电子印章只能是png格式
				const isImage = file.type === 'image/png'; 
				const isLt2M = file.size / 1024 / 1024 < 5;
				this.loading4 = true;
				if (!isImage) {
					this.$message.error('上传图片只能是 PNG 格式!');
					this.loading4 = false;
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 5MB!');
					this.loading4 = false;
				}
				return isImage && isLt2M;
			},

	// 调用组件函数
	handleUploadImage(data) {
		//   console.log('开始上传图片:', file)
		// 创建 FormData
		const formData = new FormData()
		formData.append('file', data.file)
		// 使用 Fetch API 发送请求
		fetch(this.uploadUrl, {
			method: 'POST',
			headers: this.uploadHeaders,
			body: formData,
		}).then(res => res.json()).then(res => {
			// console.log('上传成功，返回数据:', res)
			// this.$message.success('上传成功！')
			this.form.supportingMaterial.signature = res.downloadUrl;
			this.$refs.form.validateField('supportingMaterial.signature');
			this.loading3 = false;
		}).catch(error => {
			this.$message.error('上传失败：' + error.message)
			throw error
		})
    },


			// 修改证件类型下拉
			selectChanged(value){
				// console.log(value)
				if(value == "身份证"){
					this.form.identityType = '1'
					this.isDisabled = true
				}else if(value == "军官证"){
					this.form.identityType = '10'
					this.isDisabled = false
				}else if(value == "学生证"){
					this.form.identityType = '11'
					this.isDisabled = false
				}else if(value == "其他证件"){
					this.form.identityType = '9'
					this.isDisabled = false
				}
			},
			// 改变证件是否有效期单选
			changeLongValid(value){
				// console.log(value);
				this.form.longValid = value
			},
		}
	}
</script>

<style lang='scss' scoped>
	@import "../../../../assets/css/inputForm.scss";
	@import '../../../../assets/css/mine.scss';

	.el-col-2{
		text-align: center;
	}

	.right-SecondTitle {
		position: relative;
		padding: 24px 0;

		.h4 {
			font-size: 16px;
			font-weight: 500;
			color: rgba(0, 18, 22, 0.85);
		}

		a {
			position: absolute;
			right: 0;
			top: 26px;
		}

		.line {
			width: 100%;
			height: 2px;
			margin-top: 20px;
			background: rgba(0, 0, 0, 0.02);
		}
	}

	.fl {
		float: left;
	}

	.clear {
		clear: both;
		display: block;
	}

	.formPersonal {
		.blockReminder {
			width: 480px;
			background: rgba(255, 231, 186, 0.2);
			border: 1px solid #FFD591;
			padding: 16px;
			margin-top: 8px;
			line-height: 1.5;

			.h3 {
				font-size: 16px;
				font-weight: 600;
				color: rgba(0, 18, 22, 0.65);
				margin-bottom: 8px;
			}

			.description {
				font-size: 12px;
				font-weight: 400;
				color: rgba(0, 18, 22, 0.5);
			}
		}
		.blockReminder2{
			width: 200px;
			position: absolute;
			right: -220px;
			margin-top: 0;
			top: 0;
			padding: 0 16px;
			line-height: 38px;
			border-radius: 4px;
		}

		.exampleimg {
			background: url('https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/exampleIDcard.png') no-repeat;
			background-size: auto 48px;
			width: 327px;
			height: 48px;
		}
	}

	.conPersonal {
		.MainStepsForm {
			.formWrap {
				width: 568px;
			}
		}

		.uploadIDcard {
			width: 780px;
			.Uploader {
				width: 180px;
				height: 140px;
				background: #F9FAFC;
				border-radius: 4px;
				border: 1px solid #C0CCDA;
				margin-right: 16px;
				position: relative;
			}

			.Uploader:hover {
				border-color: #007DFF;
			}

			.avatar-uploader-icon {
				font-size: 28px;
				color: #8c939d;
				text-align: center;
				margin-top: 40px;
				p{
					font-size: 14px;
					line-height: 40px;
				}
			}

			.avatar {
				width: auto;
				max-width: 100%;
				height: auto;
				max-height: 100%;
				display: block;
				position: absolute;
				top:50%; 
				left:50%;
				transform: translate(-50%,-50%);
			}
		}

		.Uploader2 {
			width: 180px;
    		height: 132px;
			background: #F9FAFC;
			border-radius: 4px;
			border: 1px solid #C0CCDA;
			position: relative;
			img{
				width: auto;
				max-width: 100%;
				height: auto;
				max-height: 100%;
				position: absolute;
				top:50%; 
				left:50%;
				transform: translate(-50%,-50%);
			}

			.avatar-uploader-icon {
				font-size: 28px;
				color: #8c939d;
				text-align: center;
				line-height: 130px;
			}
		}

		.exampleWrap {
			margin-top: 8px;
		}

		/deep/.el-col-8 {
			padding-right: 8px;
		}

		/deep/.el-col-8:last-child {
			padding-right: 0px;
		}

		/deep/.el-upload {
			display: block;
		}
	}

	.resultPersonal {
		.resultwrap {
			margin-bottom: 16px;
			padding: 24px 24px 24px 80px;
			box-sizing: border-box;
			background: #F5FDFD;
			border-radius: 2px;
			border: 1px solid #D3DCE6;
			position: relative;
			font-size: 16px;
			font-weight: 600;
			color: rgba(0, 18, 22, 0.65);
			line-height: 24px;

			.icon {
				color: #0A4FD1;
				font-size: 40px;
				position: absolute;
				top: 24px;
				left: 24px;
			}
		}

		.IDcardwrap {
			.IDcard {
				width: 200px;
				height: 140px;
				background: #F9FAFC;
				border-radius: 4px;
				border: 1px solid #C0CCDA;
				overflow: hidden;
			}

			.IDcard:first-child {
				margin-right: 16px;
			}
			
			
			.IDcard img{
				width: 200px;
				height: 140px;
			}
			
		}

	}
	
	.iconRotate{
		display: block;
		width: 180px;
		float: left;
		font-size: 24px;
		color: #999;
		cursor: pointer;
	}
	.iconRotate:nth-child(2){
		margin-right: 16px;
	}
		
	.uploadBusinessLicense{position: relative;height: 132px;}
	.originalUpload{position: absolute;left: 200px;bottom: 0;}
	.originalUpload button{display: block;margin: 0;width: 100px;}


@media screen and (max-width: 991px){
	.conPersonal .MainStepsForm .formWrap{width: 100%;}
	/deep/.el-form-item__label{padding-right: 12px!important;}
	.conPersonal .uploadIDcard .Uploader{float: none;margin-bottom: 10px;}
	.formPersonal .exampleimg{background-size: 100% 48px;}
	.conPersonal .uploadIDcard,.formPersonal .blockReminder,.formPersonal .exampleimg{width: 100%;}
}
	
</style>
